/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateGetParameterSchemaResponse {
    getFixupPrototypeFunction() { return TemplateGetParameterSchemaResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateGetParameterSchemaResponse>): TemplateGetParameterSchemaResponse {
        let obj = Object.assign(new TemplateGetParameterSchemaResponse(), model);
        TemplateGetParameterSchemaResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateGetParameterSchemaResponse>): TemplateGetParameterSchemaResponse {
        if (!model) return null;
        return TemplateGetParameterSchemaResponse.newInstance(<TemplateGetParameterSchemaResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateGetParameterSchemaResponse) {
        if (!obj) return;

        models.TemplateGetParameterSchemaResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateGetParameterSchemaResponse): boolean {
        Object.setPrototypeOf(obj, TemplateGetParameterSchemaResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.input_parameters) {
            for (let val of this.input_parameters) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
        if (this.output_parameters) {
            for (let val of this.output_parameters) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    /**
     * List of input parameters.
     */
    input_parameters: Array<models.NamedParameter>;

    /**
     * List of output parameters.
     */
    output_parameters: Array<models.NamedParameter>;

}
